// @flow
import React, { useEffect } from 'react';
import classNames from 'classnames';
import { RouteNames } from 'router';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { HomeActions } from 'modules/home/actions';
import { bindActionCreators } from 'redux';
import { InfoLinks } from 'components/molecules/infoLinks';
import Offerings from 'components/molecules/offerings';
import { SocialLinks } from 'components/molecules/socialLinks';
import { HomeSelector } from 'modules/home/selector';
import { CmsPagesSelector } from 'modules/cmsPages/selector';
import type { SiteSettings } from 'types/common';
import { HeaderLinks } from 'components/molecules/headerButton';
import { isEmpty } from 'lodash';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  data: SiteSettings,
  history?: Object,
  onPress: () => void,
};

const HamburgerMenu = (props: Props) => {
  const {
    data,
    theme,
    onPress,
    offeringPages,
    machineCraft,
    eDesign,
    getHeaderData,
    getheaderData,
  } = props;
  useEffect(() => {
    getHeaderData();
  }, []);
  if (!data) {
    return null;
  }
  const infoLinks = [
    !isEmpty(offeringPages.aboutData)
      ? { title: 'About', link: RouteNames.about }
      : {},
    !isEmpty(offeringPages.careerData)
      ? { title: 'Careers', link: RouteNames.careers }
      : {},
    !isEmpty(offeringPages.contactData)
      ? { title: 'Contact', link: RouteNames.contact }
      : {},
    // { title: 'Blog', link: RouteNames.blog },
  ];
 
  const offerings = [
    !isEmpty(machineCraft)
      ? {
          title: 'Machine Craft',
          // link: '/homes#machine-craft',
          link: '/homes',
          sectionId: 'machine-craft',
        }
      : {},
    !isEmpty(offeringPages.craftBeerData)
      ? { title: 'Craft Beer', link: '/craftbeer-and-brewery' }
      : {},
    !isEmpty(eDesign)
      ? {
          title: 'eDesign',
          // link: '/homes#eDesign',
          link: '/homes',
          sectionId: 'eDesign',
        }
      : {},
    !isEmpty(offeringPages.propertyData)
      ? { title: 'Property Management', link: '/property-management' }
      : {},
    !isEmpty(offeringPages.thinkDesignData)
      ? { title: 'Think Design', link: '/think-design' }
      : {},
    // !isEmpty(offeringPages.musicData)
    //   ? { title: 'Music Foundation', link: '/music-and-events' }
    //   : {}
  ];

  const socialLinks = data.social;

  const linksContainerClass = classNames('hamburger-links-container');
  
  return (
    <div className={'hamburger-body'}>
      <div className={linksContainerClass}>
        <div>
          <Offerings links={offerings} onPress={onPress} />
          <InfoLinks links={infoLinks} connectRoute={true} />
          <HeaderLinks links={getheaderData} connectRoute={true} />
        </div>
        <div>
          <SocialLinks theme={theme} links={socialLinks} />
          {/*TODO : Added br for the iphone issue */}
          <br /> <br />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    offeringPages: HomeSelector.showOfferingPages(state),
    machineCraft: CmsPagesSelector.getCmsPages(state, 'Machine-craft', false),
    getheaderData: HomeSelector.getHeaderData(state),
    eDesign: CmsPagesSelector.getCmsPages(
      state,
      'Customise With eDesign',
      false
    ),
  };
};
const mapDispatchToProps = dispatch => {
  const { getHeaderData } = HomeActions;
  return bindActionCreators(
    {
      getHeaderData,
    },
    dispatch
  );
};



const connectedComponent = connect(mapStateToProps, mapDispatchToProps)(HamburgerMenu);

export default withRouter(connectedComponent);
